import http from '@/http'
const URL = '/admin/hotels/allocations'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}?`))
  }
  return one
}

export const saveAllocation = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const postAllData = (payload) => {
  return http.post(URL + '/all', payload)
}

export const postGroupData = (payload) => {
  return http.post(URL + '/group', payload)
}

export const delAllocation = async (id) => http.delete(URL + `/${id}`)

export default {
  list,
  show,
  saveAllocation,
  postAllData,
  postGroupData,
  delAllocation
}
